/*
 * Copyright (c) 2017-2026 Brighter AI Technologies GmbH. All rights reserved.
 * Unauthorized use, copying, reproduction, or distribution of this file, via any medium,
 * is strictly prohibited.
 */

import * as React from "react";
import {
  Card,
  Typography,
  CardActions,
  Button,
  CardContent,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { useGetOne } from "react-admin";

const useStyles = makeStyles((theme) => ({
  root: {
    boxSizing: "border-box",
    padding: 20,
    marginBottom: theme.spacing(5),
    display: "flex",
    justifyContent: "space-between",
  },
}));

function determineRemainingTrialDays(creationTime) {
  const firstDate = new Date(creationTime);
  const currentDate = new Date();

  const trial_days = 14;
  const oneDay = 24 * 60 * 60 * 1000;

  const diffDays = Math.floor(Math.abs((currentDate - firstDate) / oneDay));
  return trial_days - diffDays;
}

const TrialReminder = () => {
  const classes = useStyles();
  const { data } = useGetOne("users", "me");

  if (!data || data.subscriptionStatus !== "trial") {
    return <div></div>;
  }

  const remainingDays = determineRemainingTrialDays(data.createdAt);
  let trialMessage =
    remainingDays > 0
      ? "Your trial period is ending in " + remainingDays + " days."
      : "Your free trial has expired.";

  return (
    <Card className={classes.root}>
      <CardContent>
        <Typography variant="body1">
          {trialMessage} Contact us to upgrade to an Enterprise plan.
        </Typography>
      </CardContent>
      <CardActions>
        <Button
          variant="contained"
          href="https://brighter.ai/brighter-redact-enterprise"
        >
          CONTACT US
        </Button>
      </CardActions>
    </Card>
  );
};

export { TrialReminder };
